export const HTML_FONT_SIZE = 16

export const utils = {
  desktopSidebarWidth: {
    open: 240,
    close: 72,
  },
}
// Breakpoints for mediaqueries
// TODO: Review grid breakpoints
export const SMALL_BREAKPOINT = 667 //sm
export const MEDIUM_BREAKPOINT = 768 //md
export const LARGE_BREAKPOINT = 1024 //lg
export const EXTRALARGE_BREAKPOINT = 1200 //xl
export const EXTRAEXTRALARGE_BREAKPOINT = 1400 //xXl
